import { render, staticRenderFns } from "./teleconsultas.vue?vue&type=template&id=19e29f3c&scoped=true&"
import script from "./teleconsultas.vue?vue&type=script&lang=js&"
export * from "./teleconsultas.vue?vue&type=script&lang=js&"
import style0 from "./teleconsultas.vue?vue&type=style&index=0&id=19e29f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e29f3c",
  null
  
)

export default component.exports